import { useEffect, useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { Toaster } from 'sonner';
import { PwaStatus } from '@/components/layout/PwaStatus';
import { useAuthStore } from '@/lib/auth-store';
import { initNativeApp } from '@/lib/native';
import { appPushTokenChanged } from '@/lib/push';
import { queryClient } from '@/lib/query-client';
import { bootstrapSession } from '@/lib/session';
import { createAppRouter } from './router';

export function App() {
  const [router] = useState(createAppRouter);
  // Signed in, the application shell shows these notices under its header; the offline
  // screen explains the situation itself.
  const signedIn = useAuthStore((s) => s.status === 'authenticated' || s.status === 'offline');
  useEffect(() => {
    void bootstrapSession();
  }, []);
  useEffect(() => {
    // Inside the Android app: notification taps and links Android opens here (Phase 3J).
    void initNativeApp((path) => void router.navigate(path), appPushTokenChanged).catch(() => undefined);
  }, [router]);
  return (
    <QueryClientProvider client={queryClient}>
      {signedIn ? null : <PwaStatus />}
      <RouterProvider router={router} />
      <Toaster richColors closeButton position="top-center" />
    </QueryClientProvider>
  );
}
